import { useTranslation } from 'react-i18next'
import { styled } from '@mui/styles'
import { Stack } from '@mui/system'
import { muiTheme } from '@pbt/pbt-ui-components'
import WarningRound from '@pbt/pbt-ui-components/src/icons/WarningRound'

import SystemMessageLabel from '~/components/common/SystemMessageLabel'
import { SendGearIcon as SystemMessageIcon } from '~/components/elements/Icons/generated'

const StyledWarningRound = styled(WarningRound)(({ theme }) => ({
  fontSize: '2.4rem',
  color: theme.colors.uiNeedsAttention,
}))

const ConversationAssignedCell = ({
  assigneeName,
  id,
  isSystemMessage,
}: {
  assigneeName?: string
  id?: string
  isSystemMessage?: boolean
}) => {
  const { t } = useTranslation(['Common'])

  if (isSystemMessage) {
    return (
      <SystemMessageLabel
        color={muiTheme.colors.grayGray3}
        fontSize="H3"
        icon={<SystemMessageIcon sx={{ color: muiTheme.colors.grayGray3 }} />}
      />
    )
  }

  if (assigneeName) {
    return <>{assigneeName}</>
  }

  return (
    <Stack direction="row" spacing={1}>
      {id && <StyledWarningRound />}
      <p>{t('Common:UNASSIGNED')}</p>
    </Stack>
  )
}

export default ConversationAssignedCell
